/**
 * Failedor use with filter: "agDateColumnFilter" in ag-grid columns
 *
 * datetime normalized to midnight to ensure only the date part is compared, ignoring time.
 *
 * @param filterLocalDateAtMidnight - The filter date, always midnight.
 * @param cellValue - The cell's date value as a string
 * @returns -1 if the cell date is before the filter date, 1 if after, or 0 if equal.
 */
export const agGridDateComparator = (
  filterLocalDateAtMidnight: Date,
  cellValue: string,
) => {
  // set to midnight to ignore time
  const cellDate = new Date(new Date(cellValue).setHours(0, 0, 0, 0));

  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
};
